'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = createAsyncTypes;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _config = require('./config.js');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createAsyncTypes(type) {
  var _ref;

  var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _config2.default.delimiter;

  !(type && typeof type === 'string') ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'createAsyncTypes expected a string for type, but got %s', type) : (0, _invariant2.default)(false) : void 0;
  !(typeof delimiter === 'string') ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'createAsyncTypes expected a string for delimiter, but got %s', delimiter) : (0, _invariant2.default)(false) : void 0;
  var start = _config2.default.start,
      next = _config2.default.next,
      complete = _config2.default.complete,
      error = _config2.default.error;

  return _ref = {}, (0, _defineProperty3.default)(_ref, start, type + delimiter + _config2.default.start), (0, _defineProperty3.default)(_ref, next, type + delimiter + _config2.default.next), (0, _defineProperty3.default)(_ref, error, type + delimiter + _config2.default.error), (0, _defineProperty3.default)(_ref, complete, type + delimiter + _config2.default.complete), (0, _defineProperty3.default)(_ref, 'toString', function toString() {
    return type;
  }), _ref;
}


//////////////////
// WEBPACK FOOTER
// ./~/berkeleys-redux-utils/lib/create-async-types.js
// module id = 570
// module chunks = 168707334958949